import {User} from 'lucide-react';
import type {CallIdentity} from '../model/types';
import {initialsOf} from '../model/identity';
import {avatarTone} from '../services/avatarTone';

const SIZES = {
    20: {box: 'h-5 w-5 rounded-[6px] text-[9px]', icon: 12},
    28: {box: 'h-7 w-7 rounded-lg text-[11px]', icon: 14},
    32: {box: 'h-8 w-8 rounded-[10px] text-xs', icon: 16},
    40: {box: 'h-10 w-10 rounded-xl text-sm', icon: 20},
    48: {box: 'h-12 w-12 rounded-[14px] text-base', icon: 24},
    64: {box: 'h-16 w-16 rounded-[20px] text-xl', icon: 28},
    96: {box: 'h-24 w-24 rounded-[22px] text-[28px]', icon: 40},
    128: {box: 'h-32 w-32 rounded-[28px] text-4xl', icon: 52},
} as const;

export type CallAvatarSize = keyof typeof SIZES;

export const CallAvatar = ({identity, size, className = ''}: {identity: CallIdentity; size: CallAvatarSize; className?: string}) => {
    const {box, icon} = SIZES[size];
    const initials = initialsOf(identity);
    return (
        <span
            aria-hidden="true"
            className={`${avatarTone(identity)} ${box} inline-flex shrink-0 items-center justify-center overflow-hidden bg-[var(--phq-call-avatar-bg)] font-semibold text-[var(--phq-call-avatar-ink)] ${className}`}
        >
            {identity.avatarUrl ? (
                <img src={identity.avatarUrl} alt="" className="h-full w-full object-cover"/>
            ) : initials ? (
                initials
            ) : (
                <User size={icon} strokeWidth={2}/>
            )}
        </span>
    );
};
